import posthog from "posthog-js";

/**
 * PostHog tracking event constants
 * Following naming convention: UPPERCASE_WITH_UNDERSCORE
 */
export const TRACKING_EVENTS = {
  // Loading Screen Events
  LOADING_SCREEN_SHOWN: "loading_screen_shown",
  LOADING_SCREEN_HIDDEN: "loading_screen_hidden",

  // Onboarding Events
  ONBOARDING_SHOWN: "onboarding_shown",
  ONBOARDING_CLOSED: "onboarding_closed",
} as const;

/**
 * Type for tracking event names
 */
export type TrackingEvent = (typeof TRACKING_EVENTS)[keyof typeof TRACKING_EVENTS];

/**
 * Track a PostHog event with optional properties
 * @param event - The event name to track
 * @param properties - Optional properties to include with the event
 */
export function trackEvent(event: TrackingEvent, properties?: Record<string, any>): void {
  try {
    posthog.capture(event, properties);
  } catch (error) {
    console.error(`Failed to track event ${event}:`, error);
  }
}

/**
 * Loading screen tracking functions
 */
export const trackLoadingScreen = {
  shown: () => trackEvent(TRACKING_EVENTS.LOADING_SCREEN_SHOWN),
  hidden: () => trackEvent(TRACKING_EVENTS.LOADING_SCREEN_HIDDEN),
};

/**
 * Onboarding tracking functions
 */
export const trackOnboarding = {
  shown: () => trackEvent(TRACKING_EVENTS.ONBOARDING_SHOWN),
  closed: (properties?: { completed?: boolean; screenIndex?: number }) =>
    trackEvent(TRACKING_EVENTS.ONBOARDING_CLOSED, properties),
};
